// extracted by mini-css-extract-plugin
export var arrow = "technoCardSection-module--arrow--2d348";
export var bgDesktop = "technoCardSection-module--bgDesktop--6ecb6";
export var bgMobile = "technoCardSection-module--bgMobile--1c774";
export var button = "technoCardSection-module--button--190ed";
export var cards = "technoCardSection-module--cards--81499";
export var cardsContainer = "technoCardSection-module--cardsContainer--73984";
export var color = "technoCardSection-module--color--40934";
export var content = "technoCardSection-module--content--c318e";
export var desktopOnly = "technoCardSection-module--desktopOnly--b7aa5";
export var image = "technoCardSection-module--image--51341";
export var overlay = "technoCardSection-module--overlay--82596";
export var technoCard = "technoCardSection-module--technoCard--2cbe9";
export var text = "technoCardSection-module--text--2fd5a";
export var wrapper = "technoCardSection-module--wrapper--c852d";